import * as React from 'react';
import SaveIcon from '@material-ui/icons/Save';
import Drafts from '@material-ui/icons/Drafts';
import Cancel from '@material-ui/icons/Cancel';
import Restore from '@material-ui/icons/Restore';
import Update from '@material-ui/icons/Update';
import Description from '@material-ui/icons/Description';
import InsertDriveFile from '@material-ui/icons/InsertDriveFile';
import { Button, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles({
    GridRoot: {
        '& a': {
            whiteSpace: 'nowrap',
            marginRight: 10,
            marginBottom: 10
        },
        '& button': {
            padding: '4px 6px'
        }
    }
});
export const EditMatchResultActionLinks = props => {
    const classes = useStyles();
    const getBackUrl = () => {
        if (document.referrer !== window.location.href && document.referrer.includes("IndberetResultat"))
            return document.referrer;
        const backUrl = new URL(window.location.href);
        let path = backUrl.pathname.split("/");
        path.pop();
        return path.join("/");
    };
    const handleSaveButtonClick = (evt, draft) => {
        evt.preventDefault();
        if (!draft && props.user) {
            props.match.match.resultUpdatedByUserId = props.user.userId;
        }
        const matchData = Object.assign({}, props.match, Object.assign(Object.assign({}, props.match), { isDraft: draft }));
        props.onUpdateLeagueMatch(props.match.match.leagueMatchId, matchData);
    };
    const handleResetPostpone = (evt, options) => {
        evt.preventDefault();
        if (options.reset) {
        }
        if (options.postpone) {
        }
    };
    return (React.createElement(Grid, { container: true, alignItems: "center", classes: { root: classes.GridRoot }, className: "printHide" },
        React.createElement(Grid, null,
            React.createElement(Button, { variant: "contained", size: "small", color: "secondary", startIcon: React.createElement(SaveIcon, null), onClick: (evt) => handleSaveButtonClick(evt, false) }, "Gem")),
        props.settings.showDraftButton && props.showSaveDraft && React.createElement(Grid, null,
            React.createElement(Button, { variant: "contained", size: "small", color: "secondary", startIcon: React.createElement(Drafts, null), onClick: (evt) => handleSaveButtonClick(evt, true) }, "Gem kladde")),
        React.createElement(Grid, null,
            React.createElement(Button, { variant: "contained", size: "small", color: "secondary", startIcon: React.createElement(Cancel, null), href: getBackUrl(), style: { color: '#fff' } }, "Annuller")),
        props.adminMode && props.settings.showResetButton &&
            React.createElement(Grid, null,
                React.createElement(Button, { variant: "contained", size: "small", color: "secondary", startIcon: React.createElement(Restore, null), onClick: (evt) => handleResetPostpone(evt, { reset: true, postpone: false }) }, "Nulstil resultat")),
        props.adminMode && props.settings.showPostponeMatchButton &&
            React.createElement(Grid, null,
                React.createElement(Button, { variant: "contained", size: "small", color: "secondary", startIcon: React.createElement(Update, null), onClick: (evt) => handleResetPostpone(evt, { reset: false, postpone: true }) }, "Uds\u00E6t kamp")),
        React.createElement(Grid, null,
            React.createElement(Button, { variant: "contained", size: "small", color: "secondary", startIcon: React.createElement(Description, null), onClick: (e) => props.onPrint(false) }, "Udskriv holdseddel")),
        React.createElement(Grid, null,
            React.createElement(Button, { variant: "contained", size: "small", color: "secondary", startIcon: React.createElement(InsertDriveFile, null), onClick: (e) => props.onPrint(true) }, "Udskriv blank holdseddel"))));
};
